<template>
	<div class="banner-top" v-if="showBanner">
		<v-layout wrap>
			<v-flex xs12 md7 class="wrapper-information pt-8">
				<p class="mb-0 information">Esta promoción tiene una duración de 48 horas</p>
			</v-flex>
			<v-flex xs12 md5 class="wrapper-time">
				<div class="group" v-if="showTime">
					<p class="mb-0 text">Tiempo restante:</p>
					<time-promotion
						:end-date="configuration.endDate"
					/>
				</div>
				<div class="group" v-else>
					<p class="mb-0 text">LA PROMOCIÓN YA CADUCO</p>
				</div>
			</v-flex>
			<v-btn
				flat
				class="btn-auto btn-close"
				color="white"
				@click="hiddenBanner"
			>
				<v-icon size="25">highlight_off</v-icon>
			</v-btn>
		</v-layout>
	</div>
</template>
<script>
import timePromotion from '@/components/generate-app/time-promotion';

function configuration(value) {
	const endDateMiliseconds = new Date(value.endDate).getTime();
	const todayMiliseconds = new Date().getTime();
	this.showTime = endDateMiliseconds - todayMiliseconds > 0;
}

function hiddenBanner() {
	this.showBanner = false;
	this.$emit('get-banner-value', this.showBanner);
}

function data() {
	return {
		showBanner: true,
		showTime: false,
	};
}

export default {
	name: 'banner-top',
	components: {
		timePromotion,
	},
	data,
	methods: {
		hiddenBanner,
	},
	props: {
		configuration: {
			default: () => {},
			type: Object,
		},
	},
	watch: {
		configuration,
	},
};
</script>
<style lang="scss" scoped>
	.banner-top {
		background: map-get($colors, yellow);
		color: color(white);
		font-size: size(medium16);
		font-weight: 600;
		height: 68px;
		padding: 10px 7%;
		position: fixed;
		width: 100%;
		z-index: 9999;

		.information {
			font-size: size(medium22);

			@media (max-width: 830px) {
				font-size: size(medium15);
			}
		}

		.time {
			font-size: size(large32);

			@media (max-width: 830px) {
				font-size: size(medium20);
			}
		}

		.wrapper-information {
			height: 100%;
			border-right: 1px solid color(white);
			padding-right: 22px;
			text-align: right;

			@media (max-width: 830px) {
				border-right: none;
				padding-right: 0;
				text-align: center;
			}
		}

		.wrapper-time {
			padding-left: 22px;

			@media (max-width: 830px) {
				padding-left: 0;
			}
		}

		.text {
			margin-right: 16px;
			padding-top: 13px;

			@media (max-width: 830px) {
				margin-right: 0;
			}
		}

		.pt-8 {
			padding-top: 8px;
		}

		.group {
			display: flex;

			@media (max-width: 830px) {
				display: block;
				text-align: center;
			}
		}

		@media (max-width: 830px) {
			height: auto;
			padding: 4px;
		}
	}

	.btn-close {
		bottom: 0px;
		margin: auto;
		position: absolute;
		right: 17px;
		top: 0px;
		z-index: 1;
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/banner-top.vue